import { handleActions } from 'redux-actions';
import * as Actions from '../constants/actions';
import { GroupData } from '../models/Group';
import { StudentData } from '../models/Student';
import * as request from 'superagent';
import { toast } from 'react-toastify';
import {update} from "../../../node/src/controllers/group.controller";

const initialState: GroupData[] = [];

export default handleActions<GroupData[], any>(
	{
		[Actions.SET_GROUPS]: (state, action) => {
			return action.payload;
		},

		[Actions.ADD_GROUP]: (state, action) => {
			let groups = state.slice();
			groups.push(action.payload);
			addGroupAjax(action.payload);
			return groups;
		},

		[Actions.DELETE_GROUP]: (state, action) => {
			/*let groups = state.slice();
			const group = action.payload;
			groups = groups.filter((element) => {
				return element._id !== group._id;
			});
			updateGroupsAjax(groups);
			return groups;*/
			return state;
		},

		[Actions.UPDATE_PERMISSIONS]: (state, action) => {
			let groups = state.slice();
			const group = action.payload;
			const index = groups.findIndex((element) => {
				return element._id === group._id; 
			});
			groups[index] = group;
			updateGroupAjax(group);
			return groups;
		},

		[Actions.ADD_STUDENT]: (state, action) => {
			let student = action.payload;
			let group = state.find((o)=>{return o._id === student.group});
			group.students.push(student);
			let groups = state.slice();
			groups[student.group] = group;
			updateGroupAjax(group);
			return groups;
		},

		[Actions.UPDATE_STUDENT]: (state, action) => {
			let student = action.payload;
			let group = state.find((o)=>{return o._id === student.group});
			let index: number = group.students.findIndex((o)=>o._id === student._id);
			group.students[index] = student;
			let groups = state.slice();
			let groupIndex: number = groups.findIndex((o)=>o._id === student.group);
			groups[groupIndex] = {...group};
			updateGroupAjax(group);
			return groups;
		},

		[Actions.DELETE_STUDENT]: (state, action) => {
			let student = action.payload;
			let group = state.find((o)=>{return o._id === student.group});

			let index: number = group.students.findIndex((o)=>{return o._id === student._id});
			group.students.splice(index, 1);

			let groups = state.slice();
			groups[student.group] = group;
			updateGroupAjax(group);
			return groups;
		},

		[Actions.ADD_CAMPAIGN]: (state, action) => {
			let campaign = action.payload;
			let group = state.find((o)=>{return o._id === campaign.group});
			group.campaigns.push(campaign);
			let groups = state.slice();
			groups[campaign.group] = group;
			updateGroupAjax(group);
			return groups;
		},

		[Actions.UPDATE_CAMPAIGN]: (state, action) => {
			let campaign = action.payload;
			let groupIndex = state.findIndex((o)=>{
				return o._id === campaign.group});
			let group = state[groupIndex];
			let index: number = group.campaigns.findIndex((o)=>{
				return o._id === campaign._id});
			group.campaigns[index] = campaign;
			let groups = state.slice();
			groups[groupIndex] = group;
			updateGroupAjax(group);
			return groups;
		},

		[Actions.DELETE_CAMPAIGN]: (state, action) => {
			let campaign = action.payload;
			let group = state.find((o)=>{return o._id === campaign.group});

			let index: number = group.campaigns.findIndex((o)=>{return o._id === campaign._id});
			group.campaigns.splice(index, 1);

			let groups = state.slice();
			groups[campaign.group] = group;
			updateGroupAjax(group);
			return groups;
		}
	},
	initialState
);

function addGroupAjax(group){
	request.post('/groups')
	.send(group)
	.set('accept', 'json')
	.set('Authorization', localStorage.getItem('token'))
	.end((err, res) => {
		if(err){
			toast.error("Muutostasi ei voitu tallentaa. Tarkista internetyhteytesi ja yritä hetken kuluttua uudelleen.");					
		}else{
			toast.success("Ryhmä lisätty");
		}
	});
}

function updateGroupAjax(group){
	request.put('/groups')
	.send(group)
	.set('accept', 'json')
	.set('Authorization', localStorage.getItem('token'))
	.end((err, res) => {
		if(err){
			toast.error("Muutostasi ei voitu tallentaa. Tarkista internetyhteytesi ja yritä hetken kuluttua uudelleen.");					
		}else{
			toast.success("Muutos tallennettu tietokantaan");
		}
	});
}

function deleteGroupAjax(group){
	request.delete('/groups')
	.send(group)
	.set('accept', 'json')
	.set('Authorization', localStorage.getItem('token'))
	.end((err, res) => {
		if(err){
			toast.error("Muutostasi ei voitu tallentaa. Tarkista internetyhteytesi ja yritä hetken kuluttua uudelleen.");					
		}else{
			toast.success("Muutos tallennettu tietokantaan");
		}
	});
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/reducers/groups.ts